export class FilterContractSearch {
  [x: string]: string | number | Date | string[] | null;

  vin = '';
  document = '';
  contractStatus = 0;
  contractDateStart: Date | null = null;
  contractDateEnd: Date | null = null;
  validityDateStart: Date | null = null;
  validityDateEnd: Date | null = null;
  dealer = '';
  contractNumber: number | null = null;
  contractOriginalNumber = '';
  countries: string[] = [];
  globalContract = 0;
  salesTypeFordId = 0;
  productId = 0;
  rowsPage = 20; //indica a quantidade de resgistro que vem da busca no banco
  numberPage = 0; //indica o numero da pagina para a paginação
  operation: string;
  statusType: string[];

}
